

 
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { FaLinkedin, FaInfoCircle, FaUsers, FaPhoneAlt } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { PiGreaterThan } from "react-icons/pi";
import { Link, useNavigate } from "react-router-dom";
import logo from '../images/Centella-Logo.png';
import emailjs from 'emailjs-com';
 
const Footer = () => {
    const [isHovered, setIsHovered] = useState(false);
    const [email, setEmail] = useState("");
    const navigate = useNavigate();
 
    const handleCardClick = () => {
        setIsHovered(!isHovered);
    };
 
    const handleInputClick = () => {
        navigate('/contact');
    };
 
    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    };
 
    const sendEmail = (e) => {
        e.preventDefault();
        emailjs.send('service_isrdry5', 'template_tsszq6m', {
            email: email,
        }, '4h1JqCyCQAUiBn3oR')
        .then((result) => {
            console.log('Email sent successfully:', result.text);
        }, (error) => {
            console.error('Error sending email:', error.text);
        });
 
        setEmail('');
    };
 
    return (
<footer className="bg-gradient-to-r from-[#332E40] via-[#413E4E] to-[#054267] text-white py-6 w-full">
<div className="max-w-7xl mx-auto px-4 md:px-8">
<div className="flex flex-col lg:flex-row justify-between space-y-8 lg:space-y-0 lg:space-x-12 font-sofia lg:items-stretch">
<div
                        onClick={handleCardClick}
                        className={`w-full md:w-[50%] lg:w-[30%] bg-[#313131] border border-[#6FC5F0] bg-opacity-50 p-4 rounded-lg transition-transform duration-300 ease-in-out ${
                            isHovered ? 'scale-105' : ''
                        } hover:scale-105 cursor-pointer flex flex-col justify-between`}
>
<div className="flex-1">
<div className="text-blue-300 uppercase text-xl tracking-[1px] font-semibold mb-2 flex items-center">
<FaPhoneAlt className="mr-1" /> Contact Us
</div>
<div className="text-lg lg:text-2xl font-semibold mb-2">
<span className="text-gray-400">Seeking personalized support?</span> Request a call from our team
</div>
<form className="space-y-3 mb-3">
<div>
<input
                                        type="text"
                                        id="name"
                                        name="name"
                                        placeholder="Your Name"
                                        className="w-full p-3 bg-gray-800 text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 border border-white"
                                        onClick={handleInputClick}
                                    />
</div>
<div>
<input
                                        type="text"
                                        id="phone"
                                        name="phone"
                                        placeholder="Phone Number"
                                        className="w-full p-3 bg-gray-800 text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 border border-white"
                                        onClick={handleInputClick}
                                    />
</div>
<button type="submit" className="w-full sm:w-[60%] py-3 bg-[#6FC5F0] rounded-[50px] font-semibold text-black">
                                    Send a request
</button>
</form>
</div>
<div className="mt-auto">
<Link className="text-gray-400 inline-block" to="/privacy">
                                Privacy Policy
</Link>
<Link className="text-gray-400 mt-4 ml-6 inline-block" to="/terms">
                                Terms & Conditions
</Link>
</div>
</div>
 
                    <div className="flex-1 flex flex-col justify-between">
<div className="flex flex-col lg:flex-row justify-between lg:space-x-12 lg:space-y-0">
<div className="flex-1">
<div className="uppercase text-[#6FC5F0] text-xl mb-2 flex items-center">
<FaInfoCircle className="mr-2" /> Info
</div>
<ul className="space-y-2 text-xl">
<Link to='/'><li><a className="cursor-pointer hover:text-blue-400 py-1">Platform</a></li></Link>
<Link to='/pipeline' onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}><li><a className="cursor-pointer hover:text-blue-400">Pipeline</a></li></Link> 
<Link to='/case-study' onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}><li><a className="cursor-pointer hover:text-blue-400 cursor-default">Science</a></li></Link> 
<Link to='/news-list' onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}><li><a className="cursor-pointer whitespace-nowrap hover:text-blue-400 cursor-default">Insights & Updates</a></li></Link>
                                    {/* <Link to='/teams' onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}><li><a className="cursor-pointer hover:text-blue-400">About Us</a></li></Link> */}
</ul>
</div>
 
                            <div className="flex-1 text-xl">
<div className="uppercase text-[#6FC5F0] mb-2 flex items-center">
<FaUsers className="mr-2" /> About Us
</div>
<ul className="space-y-2 text-xl">
                                    {/* <li><a href="/" className="hover:text-blue-400 cursor-pointer">Why Centella</a></li> */}
<Link to='/teams' onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}><li><a href="/teams" className="hover:text-blue-400">Team</a></li></Link>
</ul>
</div>
 
                            <div className="flex-1">
<div className="uppercase text-[#6FC5F0] text-xl mb-2 flex items-center">
<FaPhoneAlt className="mr-2" /> Contact Us
</div>
<Link to="/contact"><p className="text-white py-2 hover:text-blue-400 text-xl">connect@centella.co.in</p></Link>
</div>
 
                            <div className="flex-1">
<img src={logo} className="ml-4" height={60} width={60} alt="Centella Logo" />
</div>
</div>
 
                        <div className="mb-1">
<div className="uppercase text-[#6FC5F0] text-xl tracking-[1px] mb-2">Subscription</div>
<form onSubmit={sendEmail} className="relative w-[95%]">
<input
                                    type="email"
                                    placeholder="E-mail"
                                    className="w-full p-3 bg-gray-800 text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 border border-white pr-12"
                                    value={email}
                                    onChange={handleEmailChange}
                                />
<button type="submit" className="absolute inset-y-0 right-0 flex items-center pr-3">
<div className="border-l border-gray-500 h-6 mr-4"></div>
<span className="text-[#6FC5F0]"><PiGreaterThan /></span>
</button>
</form>
 
                            <div className="flex space-x-4 mt-3">
<a href="https://www.linkedin.com/showcase/centella-ai-therapeutics/" className="text-gray-400 hover:text-blue-400"><FaLinkedin /></a>
<a href="https://x.com/CentellaAi" className="text-gray-400 hover:text-blue-400"><FaXTwitter /></a>
</div>
</div>
</div>
</div>
</div>
 
            <div className="text-center text-gray-500 mt-4">
<p>© 2025 Centella. All rights reserved.</p>
</div>
</footer>
 
    );
};
 
export default Footer;
 

 